import {Component, OnInit} from '@angular/core';

import {BlockUI, NgBlockUI} from 'ng-block-ui';

import {HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';

import {ValidateClientIdRequest} from '../../api/models/validate-client-id-request';
import {GapClientService} from '../../api/services/gap-client/gap-client.service';
import {GlobalService} from '../../api/services/global/global.service';

declare let jQuery: any;
declare let jcf: any;

@Component({
  selector: 'app-output',
  templateUrl: './client-validate-id.component.html',
  styleUrls: ['./client-validate-id.component.css']
})
export class ClientValidateIdComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;

  private partialIdValues: string[] = [];
  protected dobValues: string[] = [];
  protected genderValues: string[] = [];
  protected citizenValues: string[] = [];

  protected clientIdIsValid = true;
  protected submitted = false;
  protected quoteIsValid: boolean;
  protected loading = false;

  private quoteId: string;

  readonly MAX_ATTEMPTS = 3;
  protected attemptsMade = 0;
  protected attemptsRemaining = 3;
  protected locked = false;

  protected serviceError: boolean;
  protected validateRequest: ValidateClientIdRequest = {};

  constructor(
    private route: Router,
    private gapClientService: GapClientService,
    private globalService: GlobalService
  ) {}

  ngOnInit() {
    this.globalService.scrollToTop();

    const url = window.parent.location.href;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      this.quoteId = httpParams.get('quoteRef');
      this.globalService.quoteRef = this.quoteId;
    }

    this.isQuoteStillValid();
  }

  private isQuoteStillValid() {
    this.blockUI.start();
    this.loading = true;

    this.gapClientService.checkQuoteValidity(this.quoteId).subscribe(
      (quoteExpiry) => {
        this.loading = false;

        if (quoteExpiry.quoteValid) {
          this.validateRequest.clientIdValue = [];
          this.quoteIsValid = true;
          this.getPartialId();
        } else {
          this.quoteIsValid = false;
        }

        this.blockUI.stop();
      },
      error1 => {
        this.blockUI.stop();
        this.serviceError = true;
      }
    );
  }

  private getPartialId() {
    this.gapClientService.getClientIdNumber(this.quoteId).subscribe(
      (partialIdResponse) => {

        this.attemptsMade = partialIdResponse.attempts ? partialIdResponse.attempts : 0;
        this.locked = partialIdResponse.locked ? partialIdResponse.locked : false;

        if (this.locked){
          this.attemptsRemaining = 0;
        } else {
          this.attemptsRemaining = this.MAX_ATTEMPTS - this.attemptsMade;
        }
        this.partialIdValues = partialIdResponse.partialIdValues;
        this.splitArray();
      },
      error1 => {
        this.serviceError = true;
      }
    );
  }

  protected isClientIdValid() {

    if (this.locked) {
      this.clientIdIsValid = false;
      return;
    }

    this.submitted = true;
    this.partialIdValues = [
      ...this.dobValues,
      ...this.genderValues,
      ...this.citizenValues
    ];

    if (this.validateIdInput()) {
      this.loading = true;

      for (let i = 0; i < this.partialIdValues.length; i++) {
        if (this.partialIdValues[i] !== '_') {
          this.validateRequest.clientIdValue[i] = this.partialIdValues[i];
        }
      }

      this.validateRequest.quoteId = this.quoteId;

      this.gapClientService.validateClientIdNumberAndRetrieveQuote(this.validateRequest).subscribe(
        (response) => {
          this.submitted = false;
          this.validateRequest.clientIdValue = [];
          this.loading = false;

          const validation = response.validateClientIdResponse;
          this.attemptsMade = validation.attempts;
          this.locked = validation.locked;

          if (this.locked) {
            this.attemptsRemaining = 0;
            this.clientIdIsValid = false;
            return;
          } else {
            this.attemptsRemaining = this.MAX_ATTEMPTS - this.attemptsMade;
          }

          if (!validation.validIdNumber) {
            return;
          }

          if (response.quoteDetailsResponse) {
            this.globalService.gapQuoteDetailsResponse = response.quoteDetailsResponse;
          }

          if (response.quotePdfResponse) {
            this.globalService.quotePdfResponse = response.quotePdfResponse;
          }

          this.route.navigateByUrl('terms-conditions');
          },
        error1 => {
          this.loading = false;
          this.serviceError = true;
        }
      );
    } else {
      this.processNumberOfAttempts();
    }
  }

  private processNumberOfAttempts() {
    if (this.attemptsMade >= this.MAX_ATTEMPTS - 1) {
      this.clientIdIsValid = false;
    }
  }

  protected addIdInput(value, index) {
    if (value !== '') {
      this.validateRequest.clientIdValue[index] = value;
    }
  }

  private validateIdInput(): boolean {
    return this.validateRequest.clientIdValue.filter(x => x !== undefined).length === 3;
  }

  private reloadJcf() {
    jQuery(function () {
      jcf.replaceAll();
    });
  }

  private splitArray() {
    this.partialIdValues.slice(0, 6).forEach(value => this.dobValues.push(value));
    this.partialIdValues.slice(6, 10).forEach(value => this.genderValues.push(value));
    this.partialIdValues.slice(10, 13).forEach(value => this.citizenValues.push(value));
  }
}
